import React from "react";

const ThemeContext = React.createContext({});

export const useThemeContext = () => React.useContext(ThemeContext);

export default ThemeContext;